export default __webpack_public_path__ + "static/survey-dark-mode-33b54a94c71821b79a6cc7a44534ce8d.png";